import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';

import type { BookingReservationStatus } from '@/types/api/queries';

import { Badge } from '@/components/ui/badge';

import {
  BOOKING_STATUS_BADGE_VARIANTS,
  BOOKING_STATUS_LABEL_KEYS,
} from '@/constants';

type BookingStatusBadgesProps = {
  status: BookingReservationStatus;
  isUnassigned: boolean;
};

export const BookingStatusBadges = (props: BookingStatusBadgesProps) => {
  const { status, isUnassigned } = props;
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <Badge variant={BOOKING_STATUS_BADGE_VARIANTS[status]}>
        {t(BOOKING_STATUS_LABEL_KEYS[status])}
      </Badge>
      {isUnassigned && (
        <Badge
          variant="destructive"
          className="gap-1"
        >
          <AlertTriangle className="size-3" />
          {t('Not assigned')}
        </Badge>
      )}
    </div>
  );
};
